<script setup lang="ts">
import { computed } from 'vue';

import AdaptiveModal from '@/shared/components/UI/AdaptiveModal.vue';

const emit = defineEmits<{
  'update:active': [value: boolean];
}>();

const props = withDefaults(
  defineProps<{
    active: boolean;
    closeLabel?: string;
  }>(),
  {
    closeLabel: 'Close'
  }
);

const modalActive = computed<boolean>({
  get: () => props.active,
  set: (value) => emit('update:active', value)
});
</script>

<template>
  <AdaptiveModal
    v-model:active="modalActive"
    :modal-props="{ size: 'xl', closeLabel }"
    :drawer-props="{ closeLabel }"
  >
    <template #header>
      <div class="overflow-hidden text-ellipsis md:hidden">
        <slot name="header-mobile" />
      </div>
      <div class="hidden flex-col gap-2 text-xl md:flex">
        <slot name="header" />
      </div>
    </template>
    <template #body>
      <div class="mt-6 flex gap-6">
        <div class="hidden basis-1/3 md:block">
          <slot name="image" />
        </div>
        <div class="grow basis-2/3 space-y-4">
          <div class="flex flex-col gap-1">
            <slot name="default" />
          </div>

          <div class="flex items-center justify-between">
            <TransitionGroup
              enter-from-class="opacity-0"
              enter-active-class="transition-opacity duration-300 "
              leave-active-class="transition-opacity duration-300 "
              leave-to-class="opacity-0"
            >
              <slot name="controls" />
            </TransitionGroup>
          </div>

          <div class="flex md:justify-end">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </template>
  </AdaptiveModal>
</template>
